"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.havePermissions = exports.DmsPermissions = void 0;
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
const havePermissions = function (permissions) {
  let all_needed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const token = (0, _DmsTokenHook.getToken)();
  if (!token || !permissions) {
    return false;
  }
  if (!Array.isArray(permissions)) {
    permissions = [permissions];
  }
  let scopes = token.scopes;
  if (!scopes) {
    scopes = [];
  }
  let all_valid = true;
  let one_valid = null;
  permissions.forEach(permission => {
    if (one_valid == null) {
      one_valid = false;
    }
    if (scopes.includes(permission)) {
      one_valid = true;
    } else {
      all_valid = false;
    }
  });
  if (one_valid == null) {
    one_valid = true;
  }
  return all_needed ? all_valid : one_valid;
};

/**
 * DmsPermissions component is used to conditionally render its children based on user permissions.
 *
 * @param {boolean} all_needed - If true, the user must have all the permissions listed in the `permissions` array to view the `children`. If false, having any one of the permissions is sufficient.
 * @param {React.ReactNode} children - The content to be displayed if the user has the required permissions.
 * @param {React.ReactNode} fallback - The content to be displayed if the user does not have the required permissions.
 * @param {string[]} permissions - An array of permission names required to view the `children`.
 *
 * @returns {React.ReactNode} - Returns `children` if the user has the necessary permissions, otherwise returns `fallback`.
 * 
 * @example
 * <DmsPermissions 
 *   permissions={['POLLUX_PERMISSION']} 
 *   all_needed={true} 
 *   fallback={<Typography variant="body1">{intl.get("NoAccess").d("You do not have access to this content.")}</Typography>}
 * >
 *   <Typography variant="h6">Read Access Content</Typography>
 *   <Typography>
 *     {intl.get("ReadAccessContent").d("You have read access to this content.")}
 *   </Typography>
 * </DmsPermissions>
 */
exports.havePermissions = havePermissions;
const DmsPermissions = _ref => {
  let {
    all_needed,
    children,
    fallback,
    permissions
  } = _ref;
  if (havePermissions(permissions, all_needed)) {
    return children;
  }
  return fallback;
};
exports.DmsPermissions = DmsPermissions;